var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"color":_vm.colorx}},[_c('vs-tab',{attrs:{"label":"Promocion de Contratos","icon":"dashboard"},on:{"click":function($event){_vm.colorx = '#8B0000';_vm.menu = 0;}}})],1),(_vm.menu == 0)?_c('div',[_c('PedidosPromociosContratosVue',{attrs:{"periodoSelect":_vm.periodoSelect,"periodoEspecifico":"1"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }